import type { Series } from './series';

export interface FeeAdjustedSeriesOpts {
  contribution?: number;
}

/**
 * Build a period-by-period Series tracking balance growth under a fee drag.
 * P = initial balance, r = annual nominal rate, f = annual fee rate (e.g. 0.01 for 1%),
 * n = compounding/fee periods per year, years = horizon.
 * Each period: balance = balance * (1 + r/n) * (1 - f/n) + contribution
 * Records the balance at integer-year boundaries (t=0..years), id = 'fee-adjusted'.
 */
export function feeAdjustedSeries(
  P: number,
  r: number,
  f: number,
  n: number,
  years: number,
  opts: FeeAdjustedSeriesOpts = {},
): Series {
  const { contribution = 0 } = opts;
  const i = r / n;
  const fPer = f / n;
  const totalPeriods = years * n;

  let balance = P;
  const points: Series['points'] = [{ t: 0, value: P }];

  for (let p = 1; p <= totalPeriods; p++) {
    balance = balance * (1 + i) * (1 - fPer) + contribution;
    if (p % n === 0) {
      points.push({ t: p / n, value: balance });
    }
  }

  return { id: 'fee-adjusted', points };
}
